import React from 'react';
import { Link as RebassLink } from 'rebass';
import { Link as InternalLink } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { css } from 'styled-components';
import { ButtonProps, buttonAndLinkVariants } from '../Button/Button';
import classNames from 'classnames';

import prettifyUrl from '../../utils/prettifyUrl';

const linkCss = css`
  /* text-decoration: none; */
  /* color: inherit; */
`;

export const withUnderlineCss = css`
  position: relative;

  &::after {
    background: currentColor;
    bottom: -4px;
    content: '';
    height: 3px;
    left: 0;
    position: absolute;
    transition: width 350ms ease-in-out;
    width: 0;
  }

  &:hover {
    &::after {
      width: 100%;
    }
  }
`;

type LinkProps = {
  variant?: ButtonProps['variant'];
};

const Link = ({
  children,
  linktype,
  href,
  withUnderline,
  link,
  colourScheme, // swallow unused props passed with spread operator
  arrow,
  justifySelf,
  animationSettings,
  className,
  variant,
  empty = false,
  ...props
}) => {
  const compositeCss = [linkCss, withUnderline && withUnderlineCss];

  if (!children && !empty) {
    return null;
  }

  // make support for this component even in StoryBlok directly (via Button component)
  if ((!href || (href && !href.url)) && link) {
    href = link;
  }

  // Check for storyblok attributes - cached_url (internal story link) or url (external link)
  if (href?.hasOwnProperty('cached_url')) {
    href = href.cached_url || href.url;
  }

  let outbound = false;
  let newWindow = false;
  if (/^https?:\/\//.test(href)) {
    outbound = true;
    newWindow = true;
  }

  if (linktype === 'email' || /^mailto:/.test(href)) {
    outbound = true;

    if (!href.startsWith('mailto:')) {
      href = 'mailto:' + href;
    }
  }

  if (outbound) {
    return (
      <OutboundLink
        href={href}
        target={newWindow ? '_blank' : '_self'}
        rel="noreferrer noopener"
        css={compositeCss}
        className={classNames(
          buttonAndLinkVariants({ variant }),
          `ff-type`,
          `ff-button--${variant}`,
          'overlayOverBkg',
          className
        )}
        {...props}
      >
        {children}
      </OutboundLink>
    );
  } else {
    return (
      <InternalLink
        to={prettifyUrl(href)}
        css={compositeCss}
        className={classNames(
          buttonAndLinkVariants({ variant }),
          `ff-type`,
          `ff-button--${variant}`,
          'overlayOverBkg',
          className
        )}
        {...props}
      >
        {children}
      </InternalLink>
    );
  }
};

export default Link;
